export default __webpack_public_path__ + "static/media/dropper.29f35b41.svg";